import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-qa": "login-form" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_login_form_password_step = _resolveComponent("login-form-password-step")
  const _component_login_form_two_factor_step = _resolveComponent("login-form-two-factor-step")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.currentStep === $data.LoginFormStep.Password)
      ? (_openBlock(), _createBlock(_component_login_form_password_step, {
          key: 0,
          "return-url": $props.returnUrl,
          "create-account-url": $props.createAccountUrl,
          onSuccess: $options.onSuccess,
          onSignUp: $options.onSignUp,
          onRequireTwoFactorAuthentication: $options.onRequireTwoFactorAuthentication,
          "data-qa": "login-form:PasswordStep"
        }, null, 8 /* PROPS */, ["return-url", "create-account-url", "onSuccess", "onSignUp", "onRequireTwoFactorAuthentication"]))
      : _createCommentVNode("v-if", true),
    ($data.currentStep === $data.LoginFormStep.TwoFactorAuthentication)
      ? (_openBlock(), _createBlock(_component_login_form_two_factor_step, {
          key: 1,
          "return-url": $props.returnUrl,
          "authentication-type": $data.twoFactorAuthenticationType,
          "user-email-address": $data.userEmailAddress,
          onSuccess: $options.onSuccess,
          onCancel: $options.onTwoFactorAuthenticationCancel,
          "data-qa": "login-form:TwoFactorStep"
        }, null, 8 /* PROPS */, ["return-url", "authentication-type", "user-email-address", "onSuccess", "onCancel"]))
      : _createCommentVNode("v-if", true)
  ]))
}